import React from 'react';
import SEO from '../Components/SEO';
import { Button } from '../Components/ui/button';

const FLUIDIFY_URL = 'https://www.fluidify.org';

function Home() {
  return (
    <>
      <SEO
        title="Fluidify"
        description="Visit Fluidify."
        keywords="Fluidify, fluidify.org"
        canonical={FLUIDIFY_URL}
      />
      <main className="dark fixed inset-0 flex items-center justify-center bg-background font-['IBM_Plex_Sans',sans-serif]">
        <Button
          variant="ghost"
          size="lg"
          asChild
          className="group h-auto gap-[0.6em] rounded-none border-0 border-b border-white/[0.12] bg-transparent px-0 py-2 text-[clamp(1.5rem,4vw,2.25rem)] font-light tracking-[-0.02em] text-white/90 shadow-none hover:bg-transparent hover:text-white"
        >
          <a href={FLUIDIFY_URL}>
            Fluidify
            <span
              className="inline-block text-[0.85em] transition-transform duration-[400ms] [transition-timing-function:cubic-bezier(0.2,0.8,0.2,1)] group-hover:translate-x-[0.35em]"
              aria-hidden="true"
            >
              →
            </span>
          </a>
        </Button>
      </main>
    </>
  );
}

export default Home;
